import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { goBackOr } from "@/lib/goBackOr";
import Navbar from "@/components/Navbar";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import RatingStars from "@/components/RatingStars";
import { Building2, ShieldCheck, Star } from "lucide-react";

const Profile = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [ratings, setRatings] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get(`/users/${userId}`),
      api.get(`/users/${userId}/ratings`),
    ]).then(([u, r]) => { setUser(u.data); setRatings(r.data); }).catch(() => {});
  }, [userId]);

  if (!user) return <div className="min-h-screen flex items-center justify-center text-slate-500">Chargement…</div>;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="flex items-start gap-6 mb-10">
          <div className="w-20 h-20 rounded-md bg-[#2D7FF9] text-white font-display font-black text-4xl flex items-center justify-center">
            {user.name?.[0]?.toUpperCase() || "U"}
          </div>
          <div className="flex-1">
            <h1 className="font-display font-black text-3xl tracking-tighter mb-2">{user.name}</h1>
            {user.company_name && (
              <div className="flex items-center gap-2 text-slate-600 text-sm mb-2">
                <Building2 className="w-4 h-4" />{user.company_name}
              </div>
            )}
            <div className="flex items-center gap-3">
              {user.kyc_status === "approved" && (
                <Badge className="bg-emerald-100 text-emerald-800">
                  <ShieldCheck className="w-3 h-3 mr-1" />
                  Encaissement Stripe OK
                </Badge>
              )}
              <div className="flex items-center gap-1 text-sm">
                <RatingStars value={Math.round(user.rating_avg || 0)} readOnly size="sm" />
                <span className="tabular-nums font-semibold">{(user.rating_avg || 0).toFixed(1)}</span>
                <span className="text-slate-500">({user.rating_count || 0} avis)</span>
              </div>
            </div>
          </div>
          <button
            type="button"
            className="text-sm text-slate-500 hover:text-[#2D7FF9]"
            onClick={() => goBackOr(navigate)}
          >
            ← Retour
          </button>
        </div>

        <h2 className="font-display font-bold text-xl mb-4">Derniers avis</h2>
        {ratings.length === 0 ? (
          <div className="text-slate-500 border border-dashed border-[#E5E7EB] rounded-lg p-10 text-center">Aucun avis pour le moment</div>
        ) : (
          <div className="space-y-3">
            {ratings.map((r) => (
              <div key={r.rating_id} className="border border-[#E5E7EB] rounded-md p-4">
                <div className="flex items-center justify-between mb-2">
                  <RatingStars value={r.stars} readOnly size="sm" />
                  <span className="text-xs text-slate-500">{new Date(r.created_at).toLocaleDateString("fr-FR")}</span>
                </div>
                {r.comment && <p className="text-sm text-slate-700">{r.comment}</p>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
